module.exports = __webpack_public_path__ + "static/img/no-photo.71c4453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-photo.png
// module id = aiou
// module chunks = 1